// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import Dialog from 'material-ui/Dialog';


class DeleteMatch extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      data_uploaded: false,
      data_error: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  componentDidMount() {
    console.log(this.state.id);
  }

  postDeletedFixture(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/delete_match/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'match_id': data});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }
  handleBack(){
    this.props.history.goBack();
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    this.postDeletedFixture(this.state.id, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    return(
      <div >
         <Dialog
                        modal={false}
                        open={true}
                        autoDetectWindowHeight={true}
                        autoScrollBodyContent={true}
                        scroll={scroll}
                        dividers={scroll === 'paper'}
        >
        <div >
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Delete Tournament</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div>
                Are you sure about deleting this match???
              </div>
            </div>
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Delete" style={{backgroundColor:'red'}}/>
              <input className="button1" type="button" value="Cancel" onClick={() => this.handleBack()}/>
            </div>
          </form>
        </div>
        </Dialog>
      </div>
    );
  }
}

export default DeleteMatch;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/deleteMatch/index.js